import { useState } from "react";
import axios from "../../axios";
import { toast } from "react-toastify";
/**
 * Gets sf time table
 * @returns
 */
let startday1;
let endday1;
let start_time1;
let end_time1;
let date;
export const getTimeTable = async (para, para1, startday, lastday) => {
  // debugger;
  const dateFormatToGetdate = (date) => {
    const startdate = new Date(date);
    const outputDate = startdate.toUTCString().replace(",", "");
    let outputDate1 = outputDate.concat("+0530");
    return outputDate1;
  };
  startday1 = dateFormatToGetdate(startday);
  endday1 = dateFormatToGetdate(lastday);
  let finalStartDay = new Date(startday1);
  let finalendDay = new Date(endday1);
  //console.log(startday1, endday1);
  let res = [];
  let response;
  let response6 = [];
  let response1 = [];
  var response2 = [];
  const helper4 = (item) => {
    return Object.entries(item).map(([name, value]) => ({ name, value }));
  };
  function convertDateFormat(dateString) {
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const convertedDate = `${year}-${month}-${day}`;
    return convertedDate;
  }
  const helper2 = (item) => {
    start_time1 = formatTime(item.start_time);
    end_time1 = formatTime(item.end_time);
    function formatTime(time) {
      var timeString = time.toString();
      while (timeString.length < 4) {
        timeString = "0" + timeString;
      }
      return timeString.slice(0, 2) + ":" + timeString.slice(2, 4) + ":00";
    }
    const resTimeManageStart = () => {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        All: 8,
      };
      let dayNo = dayMap[item.day];
      // Convert the start and end dates to UTC timestamps
      const startTimestamp = finalStartDay.getTime();
      const endTimestamp = finalendDay.getTime();
      // Loop through all dates between the start and end dates
      for (
        let timestamp = startTimestamp;
        timestamp <= endTimestamp;
        timestamp += 24 * 60 * 60 * 1000
      ) {
        date = new Date(timestamp);
        // Check if the date matches the desired day of the week
        if (date.getDay() === dayNo) {
          const dateString = date;
          const date1 = new Date(dateString);
          let formattedDate = date1.toDateString();
          formattedDate = formattedDate.concat(
            ` ${start_time1} GMT+0530 (India Standard Time)`
          );
          return formattedDate;
        }
      }
      // If no matching date was found, return null
      return null;
    };
    const resTimeManageEnd = () => {
      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        All: 8,
      };
      let dayNo = dayMap[item.day];
      // Convert the start and end dates to UTC timestamps
      const startTimestamp = finalStartDay.getTime();
      const endTimestamp = finalendDay.getTime();
      // Loop through all dates between the start and end dates
      for (
        let timestamp = startTimestamp;
        timestamp <= endTimestamp;
        timestamp += 24 * 60 * 60 * 1000
      ) {
        date = new Date(timestamp);
        // Check if the date matches the desired day of the week
        if (date.getDay() === dayNo) {
          const dateString = date;
          const date1 = new Date(dateString);
          let formattedDate = date1.toDateString();
          formattedDate = formattedDate.concat(
            ` ${end_time1} GMT+0530 (India Standard Time)`
          );
          return formattedDate;
        }
      }
      // If no matching date was found, return null
      return null;
    };
    //resTimeManage();
    const timeForAll = () => {
      let inputDate = startday;
      let date = new Date(inputDate);
      let year = date.getUTCFullYear();
      let month = String(date.getUTCMonth() + 1).padStart(2, "0");
      let day = String(date.getUTCDate()).padStart(2, "0");
      let formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    };
    const helper3 = (supplements) => {
      if (item.name === "general_lacture") {
      }
      response2 = [];
      response1 = [];
      const filtered = Object.entries(supplements || {})
        .filter(([key, value]) => value !== null)
        .reduce((obj, [key, value]) => {
          if (obj === undefined) {
            return undefined;
          }
          if (obj === null) {
            return null;
          }
          obj[key] = value;
          delete obj.id;
          return obj;
        }, {});
      // if (
      //   filtered.pre_read ||
      //   filtered.activity ||
      //   filtered.homework ||
      //   filtered.assessment ||
      //   filtered.bbb_lecture
      // ) {
      response1.push(filtered);
      // }
      response1.forEach((i) => {
        response2 = helper4(i);
      });
      return response2;
    };
    let res1 = {
      Id: item.id,
      LectureName: item?.name,
      Subject: item?.subject?.name ? item?.subject?.name : item?.name,
      Subject_id: item?.subject?.id,
      StartTime: new Date(
        `${item.day === "All"
          ? `${timeForAll()}T${start_time1}`
          : resTimeManageStart()
        }`
      ),
      EndTime: new Date(
        `${item.day === "All"
          ? `${timeForAll()}T${end_time1}`
          : resTimeManageEnd()
        }`
      ),
      IsAllDay: false,
      Events: helper3(item.supplements),
      Supplement_id: item?.supplements?.id,
      bbb_lecture_id: item?.supplements?.bbb_lecture,
      Teacher: item?.teacher?.id,
      TeacherName: item?.teacher?.name,
      LactureType: item?.lactureType,
      DisplayColor: `#${item?.subject?.color}`,
      // lectureCategory: ,
      RecurrenceRule: `FREQ=${item.day === "All" ? "DAILY" : "WEEKLY"
        };INTERVAL=1;`,
    };
    return res1;
  };

  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let standardId = para;
  let sectionId = para1;
  let timetableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );
  let startDate = convertDateFormat(startday);
  let endDate = convertDateFormat(lastday);
  if (!academicYearId || !timetableSessionId) {
    toast.error(
      "These are no allocations set for your login. Please contact school admin for the assistance."
    );
    return;
  }
  try {
    response = await axios.get(
      `/api/v1/timetable/get/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${standardId}/sectionId/${sectionId}/timetableSessionId/${timetableSessionId}?startDate=${startDate}&endDate=${endDate}`
      // `/api/v1/timetable/get/schoolId/${schoolId}/standardId/${standardId}/sectionId/${sectionId}/timetableSessionId/${timetableSessionId}/startDate/${startDate}/endDate/${endDate}`
    );

    localStorage.setItem("TimetableId", response?.data?.data[0]?.id);
    for (let i = 0; i < response.data.data[0].schedules.length; i++) {
      for (
        let k = 0;
        k < response.data.data[0].schedules[i].special_lectures.length;
        k++
      ) {
        response.data.data[0].schedules[i].special_lectures[k]["lactureType"] =
          "special_lacture";
        response6[response6.length] =
          response.data.data[0].schedules[i].special_lectures[k];
      }
      for (
        let j = 0;
        j < response.data.data[0].schedules[i].lectures.length;
        j++
      ) {
        response.data.data[0].schedules[i].lectures[j]["lactureType"] =
          "lacture";
        response6[response6.length] =
          response.data.data[0].schedules[i].lectures[j];
      }
      for (
        let l = 0;
        l < response.data.data[0].schedules[i].general_categories.length;
        l++
      ) {
        response.data.data[0].schedules[i].general_categories[l][
          "lactureType"
        ] = "general_lacture";
        response6[response6.length] =
          response.data.data[0].schedules[i].general_categories[l];
      }
    }
    response6.forEach((i) => {
      res.push(helper2(i));
    });
  } catch (err) {
    if (err.message === "No Internet Connection") {
      alert("No Internet Connection");
      return;
    }
    console.log("err", err);
  }
  return res;
};
